import configuration from 'config';
import { CommunityCustomOnboardingAPII } from 'types/models';
import apiService from './ApiService';

export type RenovacionDatadisUpdate = Omit<CommunityCustomOnboardingAPII, 'imagenes'>;

export class RenovacionDatadisService {
  readonly http = apiService;

  private apiUrl = configuration.apiUrl;

  async enviarSolicitudRenovacion(communityId: string): Promise<any> {
    const url = `${this.apiUrl}/ce/renovacion-acceso-datadis/comunidad/${communityId}/`;
    const response = await this.http.post(url);
    return response.data;
  }

  async enviarSolicitudRenovacionInscrito(inscritoId: string): Promise<any> {
    const url = `${this.apiUrl}/ce/inscritos/${inscritoId}/renovacion-acceso-datadis/`;
    const response = await this.http.post(url);
    return response.data;
  }
}

const RenovacionDatadisServiceInstance = new RenovacionDatadisService();
export default RenovacionDatadisServiceInstance;
